import { render, staticRenderFns } from "./Usersubgroup.vue?vue&type=template&id=83fb877e"
import script from "./Usersubgroup.vue?vue&type=script&lang=js"
export * from "./Usersubgroup.vue?vue&type=script&lang=js"
import style0 from "./Usersubgroup.vue?vue&type=style&index=0&id=83fb877e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports